import { render } from "./NcrmPbxCallsTable.vue?vue&type=template&id=f22a3142&scoped=true"
import script from "./NcrmPbxCallsTable.vue?vue&type=script&lang=js"
export * from "./NcrmPbxCallsTable.vue?vue&type=script&lang=js"

import "./NcrmPbxCallsTable.vue?vue&type=style&index=0&id=f22a3142&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22a3142"]])

export default __exports__